import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api';

const Wishlist = () => {
    const history = useHistory();
    const [wishlistItems, setWishlistItems] = useState([]);

    useEffect(() => {
        const stored = localStorage.getItem("wishlist");
        if (stored) {
            setWishlistItems(JSON.parse(stored));
        }
    }, []);

    /* ---------------- REMOVE FROM WISHLIST ---------------- */
    const removeFromWishlist = (id) => {
        const updated = wishlistItems.filter(item => item.productId !== id);
        setWishlistItems(updated);
        localStorage.setItem("wishlist", JSON.stringify(updated));
        window.dispatchEvent(new Event("wishlistUpdated"));
        toast.error("Removed from Wishlist");
    };

    /* ---------------- ADD TO CART ---------------- */
    const addToCart = async (productId, productName) => {
        const userId = localStorage.getItem("userId");

        if (!userId || userId === "0") {
            toast.info("Please log in to add items to cart");
            history.push("/login");
            return;
        }

        try {
            await api.post('/usercart/add-product', null, {
                params: {
                    userId,
                    productId,
                    orderQuantity: 1
                }
            });
            toast.success(`${productName} added to cart`);
        } catch (error) {
            console.error("Add to cart error:", error);
            toast.error("Failed to add item to cart");
        }
    };

    return (
        <div className="container py-5" style={{ minHeight: '80vh' }}>
            <h2 className="mb-4 text-center fw-bold">My Wishlist</h2>

            {wishlistItems.length === 0 ? (
                <div className="text-center py-5 bg-light rounded shadow-sm">
                    <h3>Your wishlist is empty</h3>
                    <p className="text-muted">Save items you love here to buy later!</p>
                    <Link to="/our-shop" className="btn btn-warning rounded-pill px-4 mt-3">
                        Start Shopping
                    </Link>
                </div>
            ) : (
                <div className="row">
                    {wishlistItems.map(item => (
                        <div key={item.productId} className="col-lg-3 col-md-4 col-sm-6 mb-4">
                            <div className="card h-100 shadow-sm border-0 position-relative">

                                {/* ➖ REMOVE BUTTON */}
                                <button
                                    onClick={() => removeFromWishlist(item.productId)}
                                    title="Remove from Wishlist"
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '12px',
                                        background: '#fff',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '32px',
                                        height: '32px',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                        cursor: 'pointer',
                                        fontSize: '22px',
                                        fontWeight: 'bold',
                                        color: '#dc3545',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 10,
                                        lineHeight: '1'
                                    }}
                                >
                                    −
                                </button>

                                <Link
                                    to={`/product/${item.productId}`}
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                >
                                    <div
                                        className="p-4 text-center bg-light"
                                        style={{
                                            height: '220px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <img
                                            src={item.image || "https://via.placeholder.com/150"}
                                            alt={item.productName}
                                            className="img-fluid"
                                            style={{ maxHeight: '180px', objectFit: 'contain' }}
                                        />
                                    </div>

                                    <div className="card-body text-center">
                                        <h6 className="fw-bold text-truncate">
                                            {item.productName}
                                        </h6>
                                        <h5 className="text-warning">
                                            ₹{item.productPrice}
                                        </h5>
                                    </div>
                                </Link>

                                {/* ACTION BUTTONS */}
                                <div className="card-footer bg-white border-0 text-center pb-4 d-flex justify-content-center gap-2">
                                    <Link
                                        to={`/product/${item.productId}`}
                                        className="btn btn-outline-dark btn-sm rounded-pill px-3"
                                    >
                                        View
                                    </Link>

                                    <button
                                        onClick={() => addToCart(item.productId, item.productName)}
                                        className="btn btn-warning btn-sm rounded-pill px-3"
                                    >
                                        Add to Cart
                                    </button>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Wishlist;
